import { Button as MantineButton } from "@mantine/core";
export default MantineButton.Group;
